'use client'

import { useDebugTranslationKeys } from '@/utils/l10n/useDebugTranslationKeys'

export function TranslationKeysDebugger() {
  useDebugTranslationKeys()

  return null
}
